import PropTypes from 'prop-types';

export const navBarPropTypes = {
  /**
   * prop to showcase the navbar when a user is authenticated.
   */
  isAuthenticated: PropTypes.bool,
  /**
   * The background color of the navbar.
   * Can be one of 'primary', 'secondary', or a custom color string.
   */
  backgroundColor: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /**
   * The type of positioning behavor of the navbar.
   * Can be one of 'absolute', 'fixed', 'relative', 'static', or 'sticky'.
   */
  position: PropTypes.oneOf([
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky',
  ]),
  /**
   * The elevation level of the navbar.
   */
  elevation: PropTypes.number,
};

export const navBarDefaultProps = {
  backgroundColor: '#FFFFFF',
  isAuthenticated: false,
};
